import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-searcher'

export function getPageType(slug) {
	if (slug === '/buscador/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
